// @flow
import { DEFAULT_BROWSER_FONT } from '../config'; // font size relative to base font size
// displayxl  38-2.375   32-2.285714286   27.6   2.3
// displayl   36-2.25    26-1.857142857   25.2   2.1
// displaym   32-2       22-1.571428571   24     2
// displays   24-1.5     20-1.428571429   18     1.5
// displayxs  21-1.3125  18-1.285714286   15.6   1.3
// bodyl      20-1.25    16-1.142857143   14.4   1.2
// bodym      16-1       14-1             12     1    <- base
// bodys      14-0.875   12-0.8571428571  10.2   0.85
// bodyxs     12-0.75    10-0.7142857143  8.64   0.72

var scale = {
  displayxl: 64 / DEFAULT_BROWSER_FONT,
  // shipa design system - 64
  displayl: 48 / DEFAULT_BROWSER_FONT,
  // shipa design system - 48
  displaym: 36 / DEFAULT_BROWSER_FONT,
  // shipa design system - 36
  displays: 26 / DEFAULT_BROWSER_FONT,
  // shipa design system - 26
  displayxs: 20 / DEFAULT_BROWSER_FONT,
  // shipa design system - 20
  bodyl: 16 / DEFAULT_BROWSER_FONT,
  // shipa design system - 16
  bodym: 14 / DEFAULT_BROWSER_FONT,
  // shipa design system - 14
  bodys: 12 / DEFAULT_BROWSER_FONT,
  // shipa design system - 12
  bodyxs: 10 / DEFAULT_BROWSER_FONT // missing in shipa design system - 10

};

var createFonts = function createFonts(defaultFontSize
/*: number */
) {
  return {
    displayxl100:
    /* deprecated */
    "\n    font-size: " + scale.displayxl * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    displayxl200: "\n    font-size: " + scale.displayxl * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    displayxl300: "\n    font-size: " + scale.displayxl * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    displayxl400: "\n    font-size: " + scale.displayxl * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    displayxl500:
    /* deprecated */
    "\n    font-size: " + scale.displayxl * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    displayl100:
    /* deprecated */
    "\n    font-size: " + scale.displayl * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    displayl200: "\n    font-size: " + scale.displayl * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    displayl300: "\n    font-size: " + scale.displayl * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    displayl400: "\n    font-size: " + scale.displayl * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    displayl500:
    /* deprecated */
    "\n    font-size: " + scale.displayl * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    displaym100:
    /* deprecated */
    "\n    font-size: " + scale.displaym * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    displaym200: "\n    font-size: " + scale.displaym * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    displaym300: "\n    font-size: " + scale.displaym * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    displaym400: "\n    font-size: " + scale.displaym * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    displaym500:
    /* deprecated */
    "\n    font-size: " + scale.displaym * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    displays100:
    /* deprecated */
    "\n    font-size: " + scale.displays * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    displays200: "\n    font-size: " + scale.displays * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    displays300: "\n    font-size: " + scale.displays * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    displays400: "\n    font-size: " + scale.displays * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    displays500:
    /* deprecated */
    "\n    font-size: " + scale.displays * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    displayxs100:
    /* deprecated */
    "\n    font-size: " + scale.displayxs * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    displayxs200: "\n    font-size: " + scale.displayxs * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    displayxs300: "\n    font-size: " + scale.displayxs * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    displayxs400: "\n    font-size: " + scale.displayxs * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    displayxs500:
    /* deprecated */
    "\n    font-size: " + scale.displayxs * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    bodyl100:
    /* deprecated */
    "\n    font-size: " + scale.bodyl * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    bodyl200: "\n    font-size: " + scale.bodyl * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    bodyl300: "\n    font-size: " + scale.bodyl * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    bodyl400: "\n    font-size: " + scale.bodyl * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    bodyl500:
    /* deprecated */
    "\n    font-size: " + scale.bodyl * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    bodym100:
    /* deprecated */
    "\n    font-size: " + scale.bodym * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    bodym200: "\n    font-size: " + scale.bodym * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    bodym300: "\n    font-size: " + scale.bodym * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    bodym400: "\n    font-size: " + scale.bodym * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    bodym500:
    /* deprecated */
    "\n    font-size: " + scale.bodym * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    bodys100:
    /* deprecated */
    "\n    font-size: " + scale.bodys * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    bodys200: "\n    font-size: " + scale.bodys * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    bodys300: "\n    font-size: " + scale.bodys * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    bodys400: "\n    font-size: " + scale.bodys * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    bodys500:
    /* deprecated */
    "\n    font-size: " + scale.bodys * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  ",
    bodyxs100:
    /* deprecated */
    "\n    font-size: " + scale.bodyxs * defaultFontSize / 10 + "rem;\n    font-weight: 100;\n    line-height: 150%;\n  ",
    bodyxs200: "\n    font-size: " + scale.bodyxs * defaultFontSize / 10 + "rem;\n    font-weight: 200;\n    line-height: 150%;\n  ",
    bodyxs300: "\n    font-size: " + scale.bodyxs * defaultFontSize / 10 + "rem;\n    font-weight: 300;\n    line-height: 150%;\n  ",
    bodyxs400: "\n    font-size: " + scale.bodyxs * defaultFontSize / 10 + "rem;\n    font-weight: 400;\n    line-height: 150%;\n  ",
    bodyxs500:
    /* deprecated */
    "\n    font-size: " + scale.bodyxs * defaultFontSize / 10 + "rem;\n    font-weight: 500;\n    line-height: 150%;\n  "
  };
};

export default createFonts;